export default "/assets/images/quiet-mode.webm?8bbfdf1872e62ec68c89be6fac43ff2e";